<div class="all-filters-field">
  <div class="filter-title">
    {{ filter.label | translate }}
  </div>
  @if (!isSlider) {
    <div class="filter-options">
      @for (option of filterOptions; track $index) {
        <div
          class="filter-option"
          [class.has-custom-slider]="
            hasCustomSliderOption && isCustomOption(option)
          "
          [class.active]="
            filterHelpers.isOptionSelected(option, selectedOptions)
          ">
          @if (!filter.isRadio) {
            <input
              type="checkbox"
              [id]="filterHelpers.generateFilterOptionId(option)"
              [checked]="
                filterHelpers.isOptionSelected(option, selectedOptions)
              "
              (change)="onCheckboxChange($event, option)"
              [disabled]="
                !filterHelpers.isOptionEnabled(
                  option,
                  selectedOptions,
                  filter,
                  filterOptions
                )
              " />
          } @else {
            <input
              type="radio"
              [id]="filterHelpers.generateFilterOptionId(option)"
              [checked]="
                filterHelpers.isOptionSelected(option, selectedOptions)
              "
              (change)="onRadioChange(option)" />
          }

          <label [for]="filterHelpers.generateFilterOptionId(option)">
            {{
              option.label
                | translate
                  : filterHelpers.getTranslationParameters(option, unit)
            }}
          </label>
          @if (
            hasCustomSliderOption &&
            isCustomOption(option) &&
            filterHelpers.isOptionSelected(option, selectedOptions)
          ) {
            <div class="filter-slider">
              <app-filter-slider
                [filter]="filter"
                [fullRangeOption]="option"
                [unit]="unit"
                [(selectedOptions)]="customSelectedOptions"
                (selectedOptionsChange)="onSliderChange()" />
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="slider"></ng-container>
  }
</div>

<ng-template #slider>
  <div class="filter-slider">
    <app-filter-slider
      [filter]="filter"
      [fullRangeOption]="filterOptions[0]"
      [unit]="unit"
      [(selectedOptions)]="selectedOptions"
      (selectedOptionsChange)="onSliderChange()" />
  </div>
</ng-template>
